module.exports = __webpack_public_path__ + "static/media/icon_hide.b784938c.png";